import React from 'react';

import productUsbPortFocus from '../../../main/assets/images/rapidFire/rapid-fire-usb-port-focus.webp';

export const FutureProof = () => {
  return (
    <section className="rapid-fire-proof-section">
      <div className="rapid-fire-proof-text">
        <h2 className="rapid-fire-proof-title">Future-Proof Design</h2>
        <p className="rapid-fire-proof-description">
          Stay ahead of the game with rapidFIRE’s USB port, enabling easy
          firmware updates and access to new features via the Vortex
          configuration app. Your receiver will evolve with the latest
          advancements in FPV technology.
        </p>
      </div>
      <div className="rapid-fire-proof-image-layout">
        <img
          src={productUsbPortFocus}
          alt="Side View, Highlighting the USB Port"
          className="rapid-fire-proof-product"
        />
      </div>
    </section>
  );
};
